import { trackRecentProjects } from '@gonfalon/dogfood-flags/dogfood-flags';
import { type Project } from '@gonfalon/projects/types';
import { projectsDetail } from '@gonfalon/rest-api/queries/projectsDetail';
import { useQueries } from '@tanstack/react-query';

import { useRecentProjectKeys } from './useRecentProjectKeys';

// TODO: consume the upcoming API endpoint instead of making individual requests for each project
export function useRecentProjects() {
  const [keys] = useRecentProjectKeys();

  const projects = useQueries({
    queries: keys.map((projectKey) => ({ ...projectsDetail({ projectKey }), enabled: trackRecentProjects() })),
  });

  const data: Project[] = [];
  for (const project of projects) {
    if (project.status === 'success') {
      data.push(project.data);
    }
  }

  const dataKeys = data.map((project) => project.key);

  return { keys: new Set(dataKeys), projects: data } as const;
}
